import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  libraries: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {
  loadLibraries ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']
    dispatch('libraries/resetLibraries', null, { root: true })
    dispatch('medias/resetMedias', null, { root: true })

    return HTTP
      .setInstance(sitekey)
      .library.getAll()
      .then((libraries) => {
        commit('ADD_LIBRARY_ITEMS', { items: libraries })
        return libraries
      })
  },

  resetLibraries ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_LIBRARY_ITEMS')
      resolve()
    })
  },

  addLibrary ({ commit, rootGetters }, { library }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .library.create(library)
      .then((library) => {
        commit('ADD_LIBRARY_ITEM', { item: library })
        return library
      })
  },
  removeLibrary ({ commit, rootGetters }, { library }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .library.delete(library)
      .then((library) => {
        commit('REMOVE_LIBRARY_ITEM', { item: library })
        return library
      })
  }
}

// mutations
const mutations = {
  ADD_LIBRARY_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_LIBRARY_ITEMS: (state) => {
    state.items = []
  },

  ADD_LIBRARY_ITEM: (state, { item }) => {
    // state.items.splice(1, 0, item)
    state.items.unshift(item)
  },

  REMOVE_LIBRARY_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/libraries.js